import { faChevronLeft } from "@fortawesome/pro-light-svg-icons/faChevronLeft";
import { faChevronRight } from "@fortawesome/pro-light-svg-icons/faChevronRight";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, CircularProgress, Stack } from "@mui/material";
import { ScrollToError } from "components/ScrollToError";
import { Responsive, ResponsiveAll } from "components/ThemeWrapper";
import { useFormikContext } from "formik";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useStore } from "state/Store";

const NavigationButtons: React.FC<{ previousLink?: string; nextLabel?: string }> = ({ previousLink, nextLabel }) => {
    const navigate = useNavigate();
    const { isSubmitting } = useFormikContext();
    const { inFlight } = useStore();
    const navigationDisabled = isSubmitting || inFlight();

    return (
        <Stack direction={"row"} justifyContent={"center"}>
            <Stack
                direction={"row"}
                spacing={1}
                sx={{
                    width: "100%",
                    maxWidth: ResponsiveAll(
                        previousLink ? "auto" : "150px",
                        previousLink ? "308px" : "150px",
                        previousLink ? "448px" : "220px",
                        previousLink ? "448px" : "220px",
                        previousLink ? "448px" : "220px",
                    ),
                    mt: 6,
                    mb: Responsive(6, 12),
                    justifyContent:
                        previousLink && !navigationDisabled
                            ? "space-between"
                            : previousLink && navigationDisabled
                              ? "flex-end"
                              : "center",
                }}
            >
                {previousLink && !navigationDisabled && (
                    <Button
                        variant={"outlined"}
                        onClick={(_) => navigate(previousLink)}
                        sx={{
                            width: 1 / 2,
                            maxWidth: Responsive(150, 220),
                            pl: 2,
                            pr: 2,
                            justifyContent: Responsive("center", "space-between"),
                        }}
                    >
                        <Box sx={{ width: 15, height: 24, display: Responsive("none", "block") }}>
                            <FontAwesomeIcon icon={faChevronLeft} style={{ fontSize: 24 }} />
                        </Box>
                        <span>Previous</span>
                        <Box sx={{ width: 15, height: 24, display: Responsive("none", "block") }} />
                    </Button>
                )}
                <Button
                    variant={"contained"}
                    type={"submit"}
                    disabled={navigationDisabled}
                    sx={{
                        width: previousLink && !navigationDisabled ? 1 / 2 : "100%",
                        maxWidth: !navigationDisabled ? Responsive(150, 220) : "auto",
                        height: 64,
                        pl: 2,
                        pr: 2,
                        justifyContent: Responsive("center", "space-between"),
                        transition: "width 0.25s",
                        "&:hover": {
                            backgroundColor: "#1e64b7",
                        },
                    }}
                >
                    <Box sx={{ width: 15, height: 24, display: Responsive("none", "block") }} />
                    <span>
                        {navigationDisabled ? (
                            <CircularProgress
                                size={32}
                                thickness={6}
                                sx={{ mt: "8px", color: "primary.contrastText" }}
                            />
                        ) : (
                            nextLabel || "Next"
                        )}
                    </span>
                    <Box sx={{ width: 15, height: 24, display: Responsive("none", "block") }}>
                        {!navigationDisabled && <FontAwesomeIcon icon={faChevronRight} style={{ fontSize: 24 }} />}
                    </Box>
                </Button>
                <ScrollToError />
            </Stack>
        </Stack>
    );
};

export default NavigationButtons;
